<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on">mdi-eye</v-icon>
      </template>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Vessel Details
        </v-card-title>
        <!-- <v-card-text> -->
        <v-container>
          <v-row>
            <v-col cols="12" sm="4" md="12">
              <span v-if="do_data">
                <v-row>
                  <v-col cols="12" sm="12" md="4" class="pt-0 mb-2">
                    Name:
                  </v-col>
                  <v-col cols="12" sm="12" md="4" class="pt-0 mb-2">
                    {{ selected_vessel.vessel_name }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="4" class="pt-0 mb-2">
                    Voyage Number:
                  </v-col>
                  <v-col cols="12" sm="12" md="4" class="pt-0 mb-2">
                    {{ selected_vessel.voyage_number }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="4" class="pt-0 mb-2">
                    Arrival Date:
                  </v-col>
                  <v-col cols="12" sm="12" md="4" class="pt-0 mb-2">
                    {{ selected_vessel.arrival_date }} {{ selected_vessel.arrival_time }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="4" class="pt-0 mb-2">
                    Departure Date:
                  </v-col>
                  <v-col cols="12" sm="12" md="4" class="pt-0 mb-2">
                    {{ selected_vessel.departure_date }} {{ selected_vessel.departure_time }}
                  </v-col>
                </v-row>
              </span>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
//import { CommonServices } from "../../services/common.services";

const vesselNamespace = createNamespacedHelpers("vessels");
const departedVesselName = createNamespacedHelpers("departed_vessels");

export default {
  data: () => ({
    //props: ["props_data"],
    dialog: false,
    do_data: null,
    //vessels: "",
    vessel: null,
    voyage_no: null,
    departure_time: null,
    shipping_line: null,
    activePicker: null,
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    modal: false,
    valid: true,
    errors: null,
    slug: "slug",
    error: false,
    inputRules: [v => !!v || "Field is required"]
  }),
  computed: {
    ...vesselNamespace.mapState({
      vessels: state => state.vessels
    }),
    ...departedVesselName.mapState({
      setDepartureDateDialog: state => state.setDepartureDateDialog,
      selected_vessel: state => state.selected_vessel
    })
  },
  watch: {
    dialog(val) {
      if (val) this.do_data = true;
    },
    vessel(val) {
      val; // || this.close();

      if (val) {
        // this.shipping_line = this.vessel.sline_name;
      }
    }
  },

  methods: {
    // ...vesselNamespace.mapActions(["fetchVessels"]),
    //...departedVesselName.mapActions(["addDepartedVessel"]),
    dirty() {},

    // console.log("add departed vessel 1", d);

    close() {
      this.dialog = false;
    }
  }
};
</script>
